// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1710":"7d51f969","2366":"3c2e46e1","2775":"60e27e1d","5521":"683c01d5","6861":"ca5f6555","9613":"c8f54a70"}[chunkId] + ".chunk.css";
};